// SearchBar.js
import React from "react";
import { TextField, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";

import SearchIcon from "@mui/icons-material/Search";
// import "./searchbox.css";

const SearchBar = ({ onSearch }) => {
  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    if (onSearch) {
      onSearch(searchTerm); // Call the onSearch function passed from the parent component
    }
  };

  return (
    <div className="row-1">
      <Grid className="sec_grid" container spacing={2}>
        <Grid size={12}>
          <TextField
            className="searchbar"
            label="Search"
            variant="outlined"
            size="small"
            onChange={handleSearch} // Trigger the search function on input change
            InputProps={{
              endAdornment: (
                <IconButton type="button" aria-label="search" size="small">
                  <SearchIcon />
                </IconButton>
              ),
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default SearchBar;
